<template>
  <div class="account scb">
    <div class="columns is-mobile">
      <div class="column is-5 is-one-third-mobile">
        <div class="svg"></div>
      </div>
      <div class="column is-7 is-two-third-mobile">
        <div class="bank-detail">
          <div class="bank-name-th">
            {{ depositAccount.bank.nameTH }}
          </div>
          <div class="bank-name-en">
            {{ depositAccount.bank.nameEN }}
          </div>
          <div class="account-name m-t-10">
            {{ depositAccount.bankAccountName }}
          </div>
          <div class="account-no">
            {{ depositAccount.bankAccountNo | bankAccountFormat }}
            <i
              class="fas fa-copy m-l-10"
              v-clipboard:copy="depositAccount.bankAccountNo"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDeposit',
  props: {
    depositAccount: {
      type: Object
    }
  },
  data() {
    return {}
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>
